import { Button } from "@mui/material";
import { useState } from "react";
import SetMaximumPeriodModal from "../modals/SetMaximumPeriodModal";
import { Settings } from "@mui/icons-material";

export default function SetMaximumPeriodButton() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button startIcon={<Settings />} variant="contained" onClick={handleOpen}>
        Set Maximum Period
      </Button>
      <SetMaximumPeriodModal open={open} onClose={handleClose} />
    </>
  );
}
